module.exports = __webpack_public_path__ + "static/media/supplier-logo.ff8f3cf5.png";